import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Alert, Card, Select, message, Divider } from "antd";

import {
  req_edit_lrs_spaceInformation,
  req_single_lrs_SpaceDeparment_open,
} from "../../api";
import storageUtils from "../../utils/storageUtils";

const { Option } = Select;

class SpaceModalDepartment extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    space: {},
    department: {},
    departments: [
      { value: "NONE", label: "未指定" },
      { value: "1051C0A0", label: "教務處" },
      { value: "1051C0A0A0", label: "教務處招生組" },
      { value: "1051C0A0B0", label: "教務處註冊組" },
      { value: "1051C0A0C0", label: "教務處課務組" },
      { value: "1051C0A0D0", label: "教務處企畫組" },
      { value: "1051C0A0E0", label: "教務處教學資源中心 " },
      { value: "1051C0B0", label: "學生事務處" },
      { value: "1051C0B0A0", label: "學務處生活輔導組" },
      { value: "1051C0B0B0", label: "學務處課外活動指導組" },
      { value: "1051C0B0C0", label: "學務處衛生保健組" },
      { value: "1051C0B0D0", label: "學務處住宿管理暨服務學習組" },
      { value: "1051C0B0E0", label: "學務處學生輔導中心" },
      { value: "1051C0C0", label: "總務處" },
      { value: "1051C0C0A0", label: "總務處事務組" },
      { value: "1051C0C0B0", label: "總務處保管組" },
      { value: "1051C0C0C0", label: "總務處營繕組" },
      { value: "1051C0C0D0", label: "總務處出納組" },
      { value: "1051C0C0E0", label: "總務處文書組" },
      { value: "1051C0C0F0", label: "總務處環安組" },
      { value: "1051C0D0", label: "研究發展處" },
      { value: "1051C0D0A0", label: "研究發展處國際交流中心" },
      { value: "1051C0D0B0", label: "研究發展處學術暨產學合作中心" },
      { value: "1051C0D0C0", label: "研究發展處推廣教育中心" },
      { value: "1051C0D0D0", label: "研究發展處創新育成中心" },
      { value: "1051C0D0E0", label: "研究發展處職涯發展中心" },
      { value: "1051C0E0", label: "進修部" },
      { value: "1051C0E0A0", label: "進修部教務組" },
      { value: "1051C0E0B0", label: "進修部學生事務組" },
      { value: "1051C0E0C0", label: "進修部總務組" },
      { value: "1051C0F0", label: "通識教育中心" },
      { value: "1051C0G0", label: "網路與資訊中心" },
      { value: "1051C0G0A0", label: "網路與資訊中心行政及諮詢服務組" },
      { value: "1051C0G0B0", label: "網路與資訊中心網路作業組" },
      { value: "1051C0G0C0", label: "網路與資訊中心校務資訊組" },
      { value: "1051C0G0D0", label: "網路與資訊中心雲端應用組" },
      { value: "1051C0H0", label: "圖書館" },
      { value: "1051C0H0A0", label: "圖書館讀者服務組" },
      { value: "1051C0H0B0", label: "圖書館採編組" },
      { value: "1051C0H0C0", label: "圖書館視聽與資訊組" },
      { value: "1051C0I0", label: "人事室" },
      { value: "1051C0I0A0", label: "人事室人力資源組" },
      { value: "1051C0I0B0", label: "人事室人事服務組" },
      { value: "1051C0J0", label: "會計室" },
      { value: "1051C0J0A0", label: "會計室歲計組" },
      { value: "1051C0J0B0", label: "會計室審核組" },
      { value: "1051C0K0", label: "秘書室" },
      { value: "1051C0K0A0", label: "秘書室行政組" },
      { value: "1051C0K0B0", label: "秘書室公共關係組" },
      { value: "1051C0K0C0", label: "秘書室校友服務組" },
      { value: "1051C0L0", label: "體育室" },
      { value: "1051D0A0", label: "生活科技學院" },
      { value: "1051D0A0A0", label: "服飾設計管理系" },
      { value: "1051D0A0B0", label: "美容造型設計系" },
      { value: "1051D0A0C0", label: "幼兒保育系" },
      { value: "1051D0A0D0", label: "餐飲系" },
      { value: "1051D0A0E0", label: "生活服務產業系" },
      { value: "1051D0A0F0", label: "運動休閒與健康管理系" },
      { value: "1051D0B0", label: "管理學院" },
      { value: "1051D0B0A0", label: "國際企業經營系" },
      { value: "1051D0B0B0", label: "財務金融系" },
      { value: "1051D0B0C0", label: "資訊管理系" },
      { value: "1051D0B0D0", label: "企業管理系" },
      { value: "1051D0B0E0", label: "連鎖加盟經營管理學士學位學程" },
      { value: "1051D0C0", label: "設計學院" },
      { value: "1051D0C0A0", label: "室內設計系" },
      { value: "1051D0C0B0", label: "視覺傳達設計系" },
      { value: "1051D0C0C0", label: "商品設計系" },
      { value: "1051D0C0D0", label: "多媒體動畫系" },
      { value: "1051D0C0E0", label: "時尚設計系" },
      { value: "1051D0C0F0", label: "漫畫系" },
      { value: "1051D0E0", label: "藝術學院" },
      { value: "1051D0E0A0", label: "美術系" },
      { value: "1051D0E0B0", label: "音樂系" },
      { value: "1051D0E0C0", label: "舞蹈系" },
      { value: "1051D0E0D0", label: "流行音樂系" },
      { value: "1051D0F0", label: "旅遊學院" },
      { value: "1051D0F0A0", label: "應用英語系" },
      { value: "1051D0F0B0", label: "旅館管理系" },
      { value: "1051D0F0C0", label: "會計資訊系" },
      { value: "1051D0F0D0", label: "餐旅管理學士學位學程" },
      { value: "1051D0F0E0", label: "養生休閒管理系" },
      { value: "1051D0G0", label: "師資培育中心" },
      { value: "1051E0A0", label: "全球刺繡研究發展中心" },
      { value: "1051E0B0", label: "語文訓練中心" },
      { value: "1051E0C0", label: "文化創意設計研發中心" },
      { value: "1051E0D0", label: "校務研究中心" },
      { value: "1051E0E0", label: "漢家幼兒園" },
      { value: "1051E0F0", label: "財團法人漢家文教基金會" },
    ],
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    //item.condition = condition;
    //console.log(item);
    const result = await req_edit_lrs_spaceInformation(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////
  handleChange = async (value) => {
    const department = await req_single_lrs_SpaceDeparment_open(value);
    this.setState({ department: department }, () => {
      const { LevelSecondCode, LevelTopCode, MustConfirmLevel } =
        this.state.department;
      const { Uid } = this.props.space;
      const item = {
        condition: "DEPARTMENT",
        MustConfirmLevel: MustConfirmLevel,
        ServiceUnitId: value,
        ConfirmorBCode: LevelSecondCode,
        ConfirmorCCode: LevelTopCode,
        Uid: Uid,
      };
      this.api_modify_item(item);
      //console.log(item); // { value: "lucy", key: "lucy", label: "Lucy (101)" }
    });
  };
  ////////////////////////////////////////////////////////////

  render() {
    const { space } = this.props;
    const { RoomCode, RoomTwName } = this.props.space;
    const { departments } = this.state;
    return (
      <Card>
        <Alert
          message={
            <div style={{ color: "red", fontSize: "1.3em" }}>
              ({RoomCode}){RoomTwName}
            </div>
          }
          type="success"
        />
        <Divider />
        <div className="row">
          <Select
            style={{ width: "100%" }}
            defaultValue={space.ServiceUnitId}
            onChange={this.handleChange}
            allowClear
          >
            {departments.map((department) => (
              <Option value={department.value} key={department.value}>
                {department.label}
              </Option>
            ))}
          </Select>
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceModalDepartment);
